/**
 * Modal management
 */

window.addEventListener('load', () => {

  const modalSelector = '.reveal#auto-open-modal';
  const modalElement = document.querySelector(modalSelector);
  
  if (modalElement) {
    const expirationDate = localStorage.getItem(`modal_${ modalElement.dataset.id }_expiration`);

    if (localStorage.getItem(`modal_${  modalElement.dataset.id  }_launched`)) {
      localStorage.removeItem(`modal_${  modalElement.dataset.id  }_launched`);
    }

    if (!expirationDate || new Date() > new Date(expirationDate)) {

      // Open the modal
      $(modalSelector).foundation('open');

      // Set expiration date to 24 hours from now
      const nextExpirationDate = new Date();
      nextExpirationDate.setDate(nextExpirationDate.getDate() + 1);
      localStorage.setItem(`modal_${modalElement.dataset.id}_expiration`, nextExpirationDate);
    }
  }

})
